import EmbeddedWebView, {
  EmbeddedWebViewProps,
} from '@euler/app/flows/common/embedded-webview/EmbeddedWebView';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';

export const EmbeddedWebViewPage = wrapNavigatorScreen(
  (props: EmbeddedWebViewProps) => {
    const navigation = useNavigation();

    useEffect(() => {
      navigation.setOptions({ title: props.title });
    }, [navigation, props.title]);

    return <EmbeddedWebView {...props} />;
  },
);
